"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _inputValidationMessage = _interopRequireDefault(require("../input-validation-message"));
var _floatLabel = _interopRequireDefault(require("../float-label"));
var _ripple = _interopRequireDefault(require("../ripple"));
require("./field-base.css");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/**
 * A form field wrapper with floating labels.
 */
var FieldBase = function FieldBase(_ref) {
  var childId = _ref.childId,
    children = _ref.children,
    className = _ref.className,
    childWrapperClassName = _ref.childWrapperClassName,
    containerProps = _ref.containerProps,
    customFieldStatus = _ref.customFieldStatus,
    _ref$enableValidation = _ref.enableValidationMessage,
    enableValidationMessage = _ref$enableValidation === void 0 ? true : _ref$enableValidation,
    error = _ref.error,
    errorMessage = _ref.errorMessage,
    errorMessageDisplayStatus = _ref.errorMessageDisplayStatus,
    floatLabelActive = _ref.floatLabelActive,
    floatLabelActiveText = _ref.floatLabelActiveText,
    _ref$floatLabelAriaHi = _ref.floatLabelAriaHidden,
    floatLabelAriaHidden = _ref$floatLabelAriaHi === void 0 ? false : _ref$floatLabelAriaHi,
    floatLabelClassName = _ref.floatLabelClassName,
    floatLabelId = _ref.floatLabelId,
    floatLabelText = _ref.floatLabelText,
    hintText = _ref.hintText,
    hintTextId = _ref.hintTextId,
    isFocused = _ref.isFocused,
    _ref$useInactiveStyle = _ref.useInactiveStyle,
    useInactiveStyle = _ref$useInactiveStyle === void 0 ? false : _ref$useInactiveStyle,
    _ref$useModifiedStyle = _ref.useModifiedStyle,
    useModifiedStyle = _ref$useModifiedStyle === void 0 ? false : _ref$useModifiedStyle,
    validationId = _ref.validationId;
  var classList = (0, _classnames["default"])('sb-fieldBase overflow-hidden', _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, className, Boolean(className)), 'sb-fieldBase--isInvalid', error), "pb0", error), 'sb-fieldBase--isFocused', isFocused), 'sb-fieldBase--modified', useModifiedStyle));
  return /*#__PURE__*/_react["default"].createElement(_ripple["default"], {
    backgroundClassName: "bg-greenLight",
    className: "sb-fieldBase__ripple"
  }, function (_ref2) {
    var ripple = _ref2.ripple,
      eventHandlers = _ref2.eventHandlers;
    return /*#__PURE__*/_react["default"].createElement("div", _extends({
      className: classList
    }, containerProps, eventHandlers), /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])('sb-fieldBase__childWrapper flex items-center', childWrapperClassName, {
        'sb-fieldBase__childWrapper--Inactive': useInactiveStyle
      })
    }, floatLabelText ? /*#__PURE__*/_react["default"].createElement(_floatLabel["default"], _extends({
      active: floatLabelActive,
      activeText: floatLabelActiveText,
      "aria-hidden": floatLabelAriaHidden,
      className: (0, _classnames["default"])(floatLabelClassName, {
        'color-red': error
      }),
      htmlFor: childId,
      id: floatLabelId,
      isFocused: isFocused,
      useInactiveStyle: useInactiveStyle
    }, eventHandlers), floatLabelText) : null, children, ripple), /*#__PURE__*/_react["default"].createElement("div", {
      className: "pl3"
    }, enableValidationMessage ? /*#__PURE__*/_react["default"].createElement(_inputValidationMessage["default"], {
      customFieldStatus: customFieldStatus,
      displayStatus: errorMessageDisplayStatus,
      error: error,
      errorMessage: errorMessage,
      id: validationId
    }) : null, hintText ? /*#__PURE__*/_react["default"].createElement("div", {
      className: "pt2",
      id: hintTextId
    }, /*#__PURE__*/_react["default"].createElement("p", null, hintText)) : null));
  });
};
FieldBase.propTypes = process.env.NODE_ENV !== "production" ? {
  childId: _propTypes["default"].string,
  children: _propTypes["default"].node.isRequired,
  childWrapperClassName: _propTypes["default"].string,
  className: _propTypes["default"].string,
  containerProps: _propTypes["default"].object,
  customFieldStatus: _propTypes["default"].bool,
  enableValidationMessage: _propTypes["default"].bool,
  error: _propTypes["default"].bool,
  errorMessage: _propTypes["default"].node,
  errorMessageDisplayStatus: _propTypes["default"].bool,
  floatLabelActive: _propTypes["default"].bool,
  floatLabelActiveText: _propTypes["default"].node,
  floatLabelAriaHidden: _propTypes["default"].bool,
  floatLabelClassName: _propTypes["default"].string,
  floatLabelId: _propTypes["default"].string,
  floatLabelText: _propTypes["default"].node,
  hintText: _propTypes["default"].node,
  hintTextId: _propTypes["default"].string,
  useInactiveStyle: _propTypes["default"].bool,
  name: _propTypes["default"].string,
  required: _propTypes["default"].bool,
  isFocused: _propTypes["default"].bool,
  validationId: _propTypes["default"].string
} : {};
var _default = exports["default"] = FieldBase;